import Inner from './inner';

export default Inner;
